module.exports = __webpack_public_path__ + "img/bg-illustration.0359ba05.svg";